"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _validateGetCityLabel = require("./validateGetCityLabel");

var _validateGetStateLabel = require("./validateGetStateLabel");

var AddressLabelTools = {
  getCityLabel: function getCityLabel() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        countryIso = _ref.countryIso,
        i18n = _ref.i18n;

    var hasDistricts = ['HK'].includes(countryIso);
    (0, _validateGetCityLabel.validateGetCityLabel)({
      countryIso: countryIso,
      i18n: i18n
    });

    if (hasDistricts) {
      return i18n.district;
    }

    return i18n.city;
  },
  getStateLabel: function getStateLabel() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        countryIso = _ref2.countryIso,
        i18n = _ref2.i18n;

    var hasProvinces = ['CA', 'CN'].includes(countryIso);
    var hasAreas = ['HK'].includes(countryIso);
    (0, _validateGetStateLabel.validateGetStateLabel)({
      countryIso: countryIso,
      i18n: i18n
    });

    if (hasProvinces) {
      return i18n.province;
    }

    if (hasAreas) {
      return i18n.area;
    }

    return i18n.state;
  }
};
var _default = AddressLabelTools;
exports["default"] = _default;